import { Injectable } from '@angular/core';

export interface IPermissionConfig {
  model:string; // specifies the key name of the model which is be used in the controller
  selectLabel:string;
  executeButtonTitle:string;
  errorMessage:string;
  modeRemove?:boolean;
}

interface IPermissionListConfig {
  [ index:string ]:IPermissionConfig;
}

@Injectable()
export class PermissionsConfigService {
  private permissionListConfig: IPermissionListConfig = {
    ADD_WEBSHOP_CUSTOMER_PERMI: {
      model: 'webshops',
      selectLabel: 'Webshops to be added',
      executeButtonTitle: 'Add selected webshops',
      errorMessage: 'You cannot execute this action because there are no available webshops to add'
    },
    REMOVE_WEBSHOP_CUSTOMER_PERMI: {
      model: 'webshops',
      selectLabel: 'Webshops to be removed',
      executeButtonTitle: 'Remove selected webshops',
      errorMessage: 'You cannot execute this action because there are no available webshops to remove',
      modeRemove: true
    },
    ADD_COUNTRIES_CUSTOMER_PERMI: {
      model: 'countries',
      selectLabel: 'Countries to be added',
      executeButtonTitle: 'Add selected countries',
      errorMessage: 'You cannot execute this action because there are no available countries to add'
    },
    REMOVE_COUNTRIES_CUSTOMER_PERMI: {
      model: 'countries',
      selectLabel: 'Countries to be removed',
      executeButtonTitle: 'Remove selected countries',
      errorMessage: 'You cannot execute this action because there are no available countries to remove',
      modeRemove: true
    },
    ADD_REGIONS_CUSTOMER_PERMI: {
      model: 'regions',
      selectLabel: 'Regions to be added',
      executeButtonTitle: 'Add selected regions',
      errorMessage: 'You cannot execute this action because there are no available regions to add'
    },
    REMOVE_REGIONS_CUSTOMER_PERMI: {
      model: 'regions',
      selectLabel: 'Regions to be removed',
      executeButtonTitle: 'Remove selected regions',
      errorMessage: 'You cannot execute this action because there are no available regions to remove',
      modeRemove: true
    },
    ADD_SUBCOMPANY_CUSTOMER_PERMI: {
      model: 'subcompanies',
      selectLabel: 'Subcompanies to be added',
      executeButtonTitle: 'Add selected subcompanies',
      errorMessage: 'You cannot execute this action because there are no available subcompanies to add'
    },
    REMOVE_SUBCOMPANY_CUSTOMER_PERMI: {
      model: 'subcompanies',
      selectLabel: 'Subcompanies to be removed',
      executeButtonTitle: 'Remove selected subcompanies',
      errorMessage: 'You cannot execute this action because there are no available subcompanies to remove',
      modeRemove: true
    }
  };

  public getConfig(actionCode:string):IPermissionConfig {
    return this.permissionListConfig[ actionCode ];
  }
}